'use client'
import BreadCrumb from '@/components/BreadCrumb';
import { getDeityDataByName } from '@/services/app.services'
import React, { useEffect, useRef, useState } from 'react'
import Image from 'next/image';
import { noto_sans, noto_serif, } from '@/globalConstants';
import { Pagination, Skeleton } from '@mui/material';
import { usePathname } from 'next/navigation';
import { DeityInfo, Prarthana } from '@/globalTypes';
import AudioPlayer from '../AudioPlayer';
import dynamic from 'next/dist/shared/lib/dynamic';
const NudgeSection = dynamic(() => import('@/components/NudgeSection'), { ssr: false });

const BASE_CLASS = "parathana"
const DeityView = ({ deitySlug }: { deitySlug: string }) => {
    const pathname = usePathname();
    const [paginationNumber, setPaginationNumber] = useState(1);
    const [audioCurrentlyPlaying, setAudioCurrentlyPlaying] = useState<Prarthana>(
        {
            "id": "",
            "title": "",
            "audio_url": "",
            "hls_audio_url": "",
            "image_url": "",
            "banner_image_url": "",
            "duration": "",
            "is_audio_available": true,
            "ui_info": {
                "image_url": "",
                "banner_image_url": ""
            }
        }
    );
    const currentAudioTagRef = useRef<{ audioTag: any, setIsPlaying: any }>({
        audioTag: undefined,
        setIsPlaying: () => { },
    });
    const [deity, setDeity] = useState<DeityInfo>({
        "title": "",
        "description": "",
        "image_url": "",
        "prarthanas": [],
        "is_audio_available": false,
        "ui_info": {
            "image_url": ""
        }
    })
    useEffect(() => {

        (async () => {
            let deity = await getDeityDataByName(deitySlug.replaceAll("-", "_").replaceAll('%20','_'));
            setDeity(deity);

        })()
        const pageNumber = JSON.parse(localStorage.getItem("prarthanaPageNumber") || '1');
        setPaginationNumber(pageNumber);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const updateCurrentPrarthana = (audio: HTMLAudioElement, action: string, prarthanaDetails: Prarthana, setIsPlaying: any) => {
        if (audioCurrentlyPlaying.id === prarthanaDetails.id) {
            if (action === 'pause') {
                audio.pause();
                setIsPlaying(false);
            } else {
                currentAudioTagRef.current.audioTag.play();
                currentAudioTagRef.current.setIsPlaying(true);
            }
        } else {
            if (currentAudioTagRef.current.audioTag) {
                currentAudioTagRef.current.audioTag.pause();
                currentAudioTagRef.current.setIsPlaying(false);

            }
            currentAudioTagRef.current = { audioTag: audio, setIsPlaying: setIsPlaying };
            setAudioCurrentlyPlaying(prarthanaDetails);
            audio.play();
            setIsPlaying(true);
        }

    }

    const handlePageChange = (pagenumber: number) => {
        setPaginationNumber(pagenumber);
    }

    useEffect(() => {
        localStorage.setItem('prarthanaPageNumber', JSON.stringify(paginationNumber));

        return (() => {
            localStorage.removeItem('prarthanaPageNumber');
        })
    }, [paginationNumber])

    return (
        <>
            <div className={`${BASE_CLASS} pt-[1rem] pb-[4rem]  md:py-[2.5rem] flex  place-content-center `}>
                <div className={`${BASE_CLASS}__container grid  gap-[1rem] md:gap-[1.5rem] w-[95%] md:w-[90%]    2xl:w-[70%]    `}>
                    <BreadCrumb pathname={pathname}></BreadCrumb>
                    <div className={`${BASE_CLASS}__deity-list-container grid gap-[40px] md:gap-[64px]`}>
                        {deity.image_url.length ? <Image src={deity.image_url} alt='Deity Banner' width={1} height={1} className='w-screen lg:hidden' priority={true}></Image> : <Skeleton variant='rounded' width={'full'} height={'300px'} className='lg:hidden'></Skeleton>}
                        <div className={`${BASE_CLASS}__header grid gap-[8px] text-[#1D4749] `}>
                            <h1 className={`${BASE_CLASS}__header__heading grid ${noto_serif.className} font-[600] text-[20px] lg:text-[2rem]  `}>
                                {deity.title.length ? deity.title : <Skeleton variant='rounded' width={'300px'} className='h-[20px] lg:h-[2rem]' ></Skeleton>}
                            </h1>
                            <p className={`${BASE_CLASS}__header__subh-heading grid ${noto_sans.className} font-[500] text-[16px] text-black `}>
                                {deity.description.length ? deity.description : <Skeleton variant='rounded' width={'300px'} className='h-[20px] lg:h-[2rem]' ></Skeleton>}
                            </p>
                        </div>
                        <div className='grid grid-cols-1 lg:grid-cols-2 gap-[80px] lg:gap-[120px] sm:px-[3rem] lg:px-0 w-[95%]'>
                            <div className=' grid lg:flex flex-col  gap-[40px] md:gap-[64px]'>
                                <div className={`${BASE_CLASS}__deities grid  gap-[1.5rem] md:gap-[40px] `}>
                                    {deity.prarthanas.length ?
                                        Array.from(deity.prarthanas).splice((paginationNumber - 1) * 5, 5).map((prarthana: Prarthana, index: number) => {
                                            return <div key={prarthana.id}>
                                                <div className='grid gap-[14px] '>
                                                    <div className={`${noto_sans.className} font-[500] text-[14px] text-[#1D4749] `}>
                                                        <span>{index + 1 + (5 * (paginationNumber - 1))}.{` `}</span>
                                                        <span>{prarthana.title}</span>
                                                    </div>
                                                    <AudioPlayer src={prarthana.audio_url} updateCurrentPrarthana={updateCurrentPrarthana} prarthanaDetails={prarthana} type='prarthana' />

                                                </div>
                                            </div>

                                        })
                                        : [1, 2, 3, 4, 5].map(() => {
                                            return <div key={Math.random()}>
                                                <div className='grid gap-[14px] '>
                                                    <div className={`${noto_sans.className} font-[500] text-[14px] text-[#1D4749] `}>
                                                        <Skeleton variant='text' width={'200px'} animation="wave" />
                                                    </div>
                                                    <Skeleton variant='rounded' width={'100%'} height={'55px'} animation="wave" />
                                                </div>
                                            </div >
                                        })}
                                </div>
                                {deity.prarthanas.length > 5 &&
                                    <Pagination count={deity.prarthanas.length < 5 ? 1 : Math.ceil(deity.prarthanas.length / 5)} shape="rounded" page={paginationNumber} onChange={(event: React.ChangeEvent<unknown>, value: number) => { handlePageChange(value) }} />
                                }
                            </div>
                            <div className='hidden lg:block'>
                                <div className='w-full h-[480px]  hidden lg:block rounded-[1.5rem] overflow-hidden bg-white'>
                                    {deity.prarthanas.length ?
                                        <Image src={deity.image_url} alt='Devta Banner' width={1} height={1} className=' w-[100%] h-[100%]  object-cover ' priority={true}></Image>
                                        :
                                        <Skeleton variant='rounded' width={'100%'} height={'100%'} animation="wave" />
                                    }
                                </div>
                            </div>
                        </div>
                    </div >
                </div>

            </div>
            <NudgeSection />
        </>
    )
}

export default DeityView